import { createRouter, createWebHistory } from 'vue-router'
const ShareACoffee = () => import('../views/share-a-coffee/ShareACoffee.vue')
const MySubscription = () => import('../views/plans/mySubscription.vue')
const ManageSubscriptionRoot = () => import('../views/manage/manageSubscriptionRoot.vue')
const ManageSubscription = () => import('../views/manage/manageSubscription.vue')

//manage subscription views
const NextShipped = () => import('../views/manage/manage_views/nextShipped.vue')
const DeliveryFreq = () => import('../views/manage/manage_views/deliveryFreq.vue')
const NextCoffee = () => import('../views/manage/manage_views/nextCoffee.vue')
const SubscriptionSize = () => import('../views/manage/manage_views/subscriptionSize.vue')
const CoffeeType = () => import('../views/manage/manage_views/coffeeType.vue')
const BrewMethod = () => import('../views/manage/manage_views/brewMethod.vue')
const SubscriptionName = () => import('../views/manage/manage_views/subscriptionName.vue')
const SubscriptionType = () => import('../views/manage/manage_views/subscriptionType.vue')
const ManageAddresses = () => import('../views/manage/manage_views//addresses/accountAddresses.vue')
const ManageAddressesEdit = () => import('../views/manage/manage_views/addresses/accountAddressesEdit.vue')
const ManageAddressesNew = () => import('../views/manage/manage_views/addresses/accountAddressesNew.vue')
const ManageAddressesRoot = () => import('../views/manage/manage_views/addresses/addressesRoot.vue')
//account details views
const AccountDetails = () => import('../views/details/accountDetails.vue')
const AccountDetailsContact = () => import('../views/details/accountDetailsContact.vue')
const AccountDetailsContactEdit = () => import('../views/details/accountDetailsContactEdit.vue')
const AccountDetailsBillingEdit  = () => import('../views/details/accountDetailsBillingEdit.vue')
const AccountDetailsBilling  = () => import('../views/details/accountDetailsBilling.vue')
const AccountCredit  = () => import('../views/details/accountCredit.vue')
const DetailsRoot = () => import('../views/details/detailsRoot.vue')

//orders history
const AccountOrderHistory = () => import('../views/history/accountOrderHistory.vue')
const AccountOrderDetails = () => import('../views/history/accountOrderDetails.vue')
const OrderHistoryRoot = () => import('../views/history/OrderHistoryRoot.vue')

const AccountContact = () => import('../views/contact/accountContact.vue')
const CoffeeRatings = () => import('../views/ratings/coffeeRatings.vue')
// replace
// import Login from '../views/Login'
// with
const Login = () => import('../views/Login.vue')
const ResetPwd = () => import('../views/ResetPwd.vue')

import Account from '../Account.vue'
import AccountRoot from '../Root.vue'

const NotFound = () => import('../views/NotFound.vue')
const B2BAccount = () => import('../views/B2B.vue')

import cookieHandler from '../../utils/cookies/cookieHandler'
import { useAuthUser } from '../../../utils/stores/modules/authUser'

const routes = [
  { path: '', name: 'B2B', component: B2BAccount },
	{
		path: '/',
		component: AccountRoot,
		children: [
			{
				path: 'account',
				name: 'Account',
				component: Account,
				redirect: '/account/my-subscription',
				beforeEnter: (to) => {
          const userStore = useAuthUser()
					// reject the navigation
					if (!cookieHandler.hasToken() && !window.location.pathname.startsWith('/reset-password') ){
            return { name: 'Login',hash: '#' + to.path }
          }
          else {
            userStore.getUserInfo()
          }
				},
				children: [
          { path: '/:pathMatch(.*)*', name: 'Not Found', component: NotFound },
					// {
					// 	path: 'my-account',
          //   name: 'my account',
					// 	component: MyAccount,
					// },
					{
						path: 'my-subscription',
            name: 'my subscription',
						component: MySubscription,
            meta: { accountTransition: 'account-fade' }
          },
          {
            path: 'manage-subscription',
            component: ManageSubscriptionRoot,
            children: [
              {
                path: '',
                name: 'manage subscription',
                component: ManageSubscription,
                meta: { accountTransition: 'account-fade' }
              },
              {
                path: 'next-shipped',
                name: 'next shipped',
                component: NextShipped,
                meta: { accountTransition: 'account-fade' }
              },
              {
                path: 'change-frequency',
                name: 'change frequency',
                component: DeliveryFreq,
                meta: { accountTransition: 'account-fade' }
              },
              {
                path: 'change-address',
                component: ManageAddressesRoot,
                beforeEnter: (to, from, next) => {
                  const userStore = useAuthUser()
                  userStore.getAddresses({ callback: (response) => {
                      if (response.status === 'ok') next()
                    }
                  })
                },
                children: [
                  {
                    path: '',
                    name: 'change address',
                    component: ManageAddresses,
                    meta: { accountTransition: 'account-fade' }
                  },
                  {
				            path: ':id/edit',
										name: 'edit subscription address',
										props: true,
                    component: ManageAddressesEdit,
                    meta: { accountTransition: 'account-fade' }
                  },
                  {
                    path: 'new',
                    name: 'add new address',
                    component: ManageAddressesNew,
                    meta: { accountTransition: 'account-fade' }
                  },
                ]
              },
              {
                path: 'change-coffee',
                name: 'change coffee',
                component: NextCoffee,
                meta: { accountTransition: 'account-fade' }
              },
              {
                path: 'change-size',
                name: 'change size',
                component: SubscriptionSize,
                meta: { accountTransition: 'account-fade' }
              },
              {
                path: 'change-coffee-type',
                name: 'change coffee type',
                component: CoffeeType,
                meta: { accountTransition: 'account-fade' }
              },
              {
                path: 'change-brew-method',
                name: 'change brew method',
                component: BrewMethod,
                meta: { accountTransition: 'account-fade' }
              },
              {
                path: 'change-subscription-name',
                name: 'change name',
                component: SubscriptionName,
                meta: { accountTransition: 'account-fade' }
              },
              {
                path: 'change-subscription-type',
                name: 'change type',
                component: SubscriptionType,
                meta: { accountTransition: 'account-fade' }
              },
            ]
          },
          {
            path: 'order-history',
            component: OrderHistoryRoot,
            beforeEnter: (to, from, next) => {
              const userStore = useAuthUser()
              const requestedYear = parseInt(to?.query?.year, 10)
              const year = !Number.isNaN(requestedYear) ? requestedYear : undefined
              userStore.loadOrdersHistoryByYear({ year }).then((response) => {
                next()
              })
            },
            redirect: { name: 'order history' },
            children: [
              {
                path: '',
                name: 'order history',
                meta: { accountTransition: 'account-fade' },
                component: AccountOrderHistory,
              },
              {
                path: ':id',
                name: 'order history details',
                meta: { accountTransition: 'account-fade' },
                component: AccountOrderDetails,
                props: (route) => ({ id: route.params.id }),
              },
            ],
          },
					{
						path: 'details',
						component: DetailsRoot,
            beforeEnter: (to, from, next) => {
              const userStore = useAuthUser()
              userStore.getUserInfo({ callback: (response) =>{
                  if(response.status === 'ok'){
                    userStore.getCards({
                      callback: (response) => {
                        if (response.status === 'ok') next()
                      }
                    })
                  }
                }
              })
            },
						children: [
							{
								path: '',
								name: 'Account Details',
								meta: { accountTransition: 'account-fade' },
								component: AccountDetails,
							},
							{
								path: 'edit-contact',
								name: 'edit contact details',
								meta: { accountTransition: 'account-fade' },
								component: AccountDetailsContactEdit,
							},
							{
								path: 'contact',
								name: 'contact details',
								meta: { accountTransition: 'account-fade' },
								component: AccountDetailsContact,
								props: true
							},
							{
								path: 'edit-billing',
								name: 'edit billing details',
								meta: { accountTransition: 'account-fade' },
								component: AccountDetailsBillingEdit,
							},
							{
								path: 'billing',
								name: 'billing details',
								meta: { accountTransition: 'account-fade' },
								component: AccountDetailsBilling,
							},
							{
								path: 'credit',
								name: 'account credit',
								meta: { accountTransition: 'account-fade' },
								component: AccountCredit,
							},
              {
                path: 'order-history',
                component: OrderHistoryRoot,
                beforeEnter: (to, from, next) => {
                  const userStore = useAuthUser()
                  const requestedYear = parseInt(to?.query?.year, 10)
                  const year = !Number.isNaN(requestedYear) ? requestedYear : undefined
                  userStore.loadOrdersHistoryByYear({ year }).then((response) => {
                    next()
                  })
                },
                redirect: { name: 'order history' },
                children: [
                  {
                    path: '',
                    name: 'account details order history',
                    meta: { accountTransition: 'account-fade' },
                    component: AccountOrderHistory,
                  },
                  {
                    path: ':id',
                    name: 'account details order history details',
                    meta: { accountTransition: 'account-fade' },
                    component: AccountOrderDetails,
                    props: (route) => ({ id: route.params.id }),
                  },
                ],
              },
						],
					},
					{
						path: 'rate-coffees',
						name: 'Rate coffees',
						component: CoffeeRatings,
            meta: { accountTransition: 'account-fade' }
					},
					{
						path: 'contact-us',
						name: 'Contact us',
						component: AccountContact,
            meta: { accountTransition: 'account-fade' }
					},
					{
						path: 'share-a-coffee',
						name: 'Refer a Friend',
						component: ShareACoffee,
            meta: { accountTransition: 'account-fade' }
					},
				],
			},
			{
				path: 'login',
				name: 'Login',
				component: Login,
				beforeEnter: (to,from) => {
          const userStore = useAuthUser()
					// reject the navigation
					if (cookieHandler.hasToken()) return '/account'
          else {
            var urlParams = new URLSearchParams(window.location.search)
            //login as cs
            if (urlParams.has('cs_mode')) {
              var token = urlParams.get('token')
              //store.dispatch('notifications/showNotification',{type: 'cs', message: 'You are in CS Mode', countdown: 300})
              userStore.getUserInfoForCsMode({cs_token: token, cs_mode: true})
            }
          }
				},
			},
			{
				path: 'reset-password',
				name: 'Reset Password',
				component: ResetPwd,
			},
		],
	},
]

const router = createRouter({
	history: createWebHistory(),
	routes
})

router.beforeEach(function (to, from, next) {
    setTimeout(() => {
        window.scrollTo(0, 0);
    }, 100);
    next()
});

export default router
